// extracted by mini-css-extract-plugin
module.exports = {"HalfHalf":"half-half_HalfHalf__OxXs_","evolved":"half-half_evolved__u7yqo"};